export default {"src":"/_next/static/media/emptyCart.3146642a.svg","height":199,"width":260,"blurWidth":0,"blurHeight":0};